import { Box, Grid } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import { MatrizDeOcorrencias } from "../../types";
import CardBox from "../../../../main/components/CardBox";
import { EChartsOption } from "echarts";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { convertTimeToMinutes } from "../../../../main/utils/utils";

export default function StringsHeatmap(props: {
    matriz: MatrizDeOcorrencias | undefined;
    currentUg: string
}) {
    const { matriz, currentUg } = props;

    let maxValue = 0;

    const areasSet = new Set<string>();
    const codesSet = new Set<string>();

    matriz?.alarms.forEach(alarm => {
        codesSet.add(alarm.code);

        alarm.inversores.forEach(inversor => {
            areasSet.add(inversor.area);
        });
    });

    const areasUnicas: string[] = Array.from(areasSet);
    const codesUnicos: string[] = Array.from(codesSet);

    const codesUnicosOrdenados = codesUnicos.sort((a, b) => {
        const numA = parseInt(a.replace("INV", ""));
        const numB = parseInt(b.replace("INV", ""));
        return numA - numB;
    })

    const areasUnicasOrdenadas = areasUnicas.sort((a, b) => {
        const numA = parseInt(a);
        const numB = parseInt(b);
        return numA - numB;
    }).reverse();

    const heatmapData: [number, number, number][] = [];

    for (let y = 0; y < areasUnicasOrdenadas.length; y++) {
        for (let x = 0; x < codesUnicosOrdenados.length; x++) {
            const alarm = matriz?.alarms.find(a => a.code === codesUnicosOrdenados[x]);
            const inversor = alarm?.inversores.find(i => i.area === areasUnicasOrdenadas[y]);
            const amount = convertTimeToMinutes(inversor?.duration ?? "") ?? 0;

            if (amount > maxValue) {
                maxValue = amount;
            }

            heatmapData.push([x, y, amount]);
        }
    }

    const options: EChartsOption = {
        title: {
            text: `Mapa de calor por tempo de duração das falhas nos strings - ${currentUg}`,
            textStyle: {
                fontSize: 12,
            },
        },
        backgroundColor: "transparent",
        tooltip: {
            position: 'top',
            formatter: function (params: any) {
                const stringNumber = areasUnicasOrdenadas[params.data[1]];
                return `
                <strong>${params.seriesName}</strong><br/>
                <strong>${params.name}, String ${stringNumber}: ${params.data[2]} min</strong>
              `;
            }
        },
        grid: {
            height: '78%',
            top: 25
        },
        xAxis: {
            type: 'category',
            data: codesUnicosOrdenados,
            position: 'top',
            splitArea: { show: true },
            axisLabel: { interval: 0 }
        },
        yAxis: {
            type: 'category',
            data: areasUnicasOrdenadas,
            splitArea: { show: true },
            axisLabel: { interval: 0 }
        },
        visualMap: {
            min: 0,
            max: maxValue,
            orient: 'horizontal',
            left: 'center',
            calculable: true,
            formatter: '{value} min'
        },
        series: [
            {
                name: 'Tempo de duração das falhas',
                type: 'heatmap',
                data: heatmapData,
                itemStyle: {
                    borderWidth: 1,
                    borderColor: "#000"
                },
                label: {
                    show: true,
                    color: '#000',
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };

    const hasData = matriz?.alarms && matriz?.alarms.length > 0;

    return (
        <>
            {hasData ? (
                <Grid sx={{ width: "90%" }} item xs={12} sm={12} md={6}>
                    <CardBox
                        sx={{
                            height: "100%",
                            width: "100%",
                            minHeight: "400px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                height: "90%",
                                width: "95%",
                            }}
                        >
                            <RopChart option={options} />
                        </Box>
                    </CardBox>
                </Grid>
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <EmptyTable title="Nenhum dado encontrado!" />
                </Box>
            )}
        </>
    );
}